import * as React from "react";

export const TermsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2.25C0 1.00898 1.00898 0 2.25 0H7.50586C8.10352 0 8.67656 0.235547 9.09844 0.657422L12.8426 4.40508C13.2645 4.82695 13.5 5.4 13.5 5.99766V15.75C13.5 16.991 12.491 18 11.25 18H2.25C1.00898 18 0 16.991 0 15.75V2.25ZM7.3125 2.05664V5.34375C7.3125 5.81133 7.68867 6.1875 8.15625 6.1875H11.4434L7.3125 2.05664ZM4.21875 9C3.75117 9 3.375 9.37617 3.375 9.84375C3.375 10.3113 3.75117 10.6875 4.21875 10.6875H9.28125C9.74883 10.6875 10.125 10.3113 10.125 9.84375C10.125 9.37617 9.74883 9 9.28125 9H4.21875ZM4.21875 12.375C3.75117 12.375 3.375 12.7512 3.375 13.2188C3.375 13.6863 3.75117 14.0625 4.21875 14.0625H9.28125C9.74883 14.0625 10.125 13.6863 10.125 13.2188C10.125 12.7512 9.74883 12.375 9.28125 12.375H4.21875Z"
      fill="currentColor"
    />
  </svg>
);
